import { useState } from 'react'

const KEY_CODES = {
  BACKSPACE: 8,
  DELETE: 46,
}

const useEvents = inputRef => {
  const [previous, setPrevious] = useState()

  const useOnChange = onChange => {
    return async value => {
      const whereInputValueIsChanged = inputRef.current?.selectionStart
      setPrevious(whereInputValueIsChanged)
      return await onChange(value)
    }
  }

  const onKeyUp = event => {
    if (!inputRef.current) return
    if (event.keyCode === KEY_CODES.BACKSPACE) inputRef.current.selectionEnd = previous
    if (event.keyCode === KEY_CODES.DELETE) inputRef.current.selectionEnd = previous
  }

  return {
    useOnChange,
    onKeyUp,
  }
}

export default useEvents
